import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { errorMessage, successMessage } from "../CommonFunctions";
import { Accordion, Button, Col, Form, Modal, Row } from "react-bootstrap";
import {
  POST_GetTestingsApprovalDetailByID,
  POST_TestingsApprovalInsert,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const TestingApproval = ({
  showTestingApprovalModal,
  setShowTestingApprovalModal,
  InwardMaterialID,
  fnCallback,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const [showTCAllTestApprovalModal, setShowTCAllTestApprovalModal] =
    useState(false);

  const [showTestMasterImagesModal, setShowTestMasterImagesModal] =
    useState(false);

  const [showTestingResultImagesModal, setShowTestingResultImagesModal] =
    useState(false);
  const [listTestMasterImages, setListTestMasterImages] = useState([]);
  const [listOfTestingResultImages, setListOfTestingResultImages] = useState(
    []
  );
  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);

  const [showTPIDetailModal, setShowTPIDetailModal] = useState(false);
  const [listOfTPIDetails, setListOfTPIDetails] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const validationSchemaApproval = Yup.object().shape({});

  const formikApproval = useFormik({
    validationSchemaApproval,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitApproval(values, formikHelpers),
    initialValues: {
      InwardMaterialIDEncrypted: "",
      ApprovalTCNo: "",
      ApprovalInwardNo: "",
      InwardDate: "",
      EDD: "",
      LetterRefNo: "",
      // DepartmentIDEncrypted: "",
      // DepartmentName: "",
      // ProductGroupIDEncrypted: "",
      // ProductGroupName: "",
      // MaterialTypeIDEncrypted: "",
      // MaterialTypeName: "",
      Size: "",
      Condition: "",
      SampleDetail: "",
      ListOfMaterialTests: [],
      ApprovalNoteForApproveAll: "",
      ListOfLetterRefDoc: [],
      IsMaterialReturnable: false,
      IsTPIRequired: false,
      IsHold: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardMaterialIDEncrypted,
      ApprovalTCNo,
      ApprovalInwardNo,
      InwardDate,
      EDD,
      LetterRefNo,
      // DepartmentName,
      // ProductGroupName,
      // MaterialTypeName,
      Size,
      Condition,
      SampleDetail,
      ListOfMaterialTests,
      ApprovalNoteForApproveAll,
      ListOfLetterRefDoc,
      IsMaterialReturnable,
      IsTPIRequired,
      IsHold,
    },
  } = formikApproval;

  const handleValidSubmitApproval = (values) => {};

  const getTCDetailForTestingApproval = async (inwardMaterialID) => {
    setIsLoading(true);
    await post(POST_GetTestingsApprovalDetailByID, {
      InwardMaterialIDEncrypted: inwardMaterialID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikApproval.setFieldValue(
            "InwardMaterialIDEncrypted",
            inwardMaterialID
          );
          formikApproval.setFieldValue("ApprovalTCNo", response?.TCNo);
          formikApproval.setFieldValue("ApprovalInwardNo", response?.InwardNo);
          formikApproval.setFieldValue("InwardDate", response?.InwardDate);
          formikApproval.setFieldValue("EDD", response?.ExpectedDateOfDelivery);
          // formikApproval.setFieldValue(
          //   "DepartmentName",
          //   response?.DepartmentName
          // );
          // formikApproval.setFieldValue(
          //   "ProductGroupName",
          //   response?.MaterialGroupName
          // );
          // formikApproval.setFieldValue(
          //   "MaterialTypeName",
          //   response?.MaterialType
          // );
          formikApproval.setFieldValue("Size", response?.Size);
          formikApproval.setFieldValue("Condition", response?.Condition);
          formikApproval.setFieldValue("SampleDetail", response?.SampleDetail);
          formikApproval.setFieldValue(
            "ListOfMaterialTests",
            response?.ListOfMaterialTests?.map((x) => ({
              TestingIDEncrypted: x?.TestingIDEncrypt,
              InwardMaterialTestDetailIDEncrypted:
                x?.InwardMaterialTestDetailIDEncrypt,
              InwardMaterialIDEncrypted: x?.InwardMaterialIDEncrypt,
              DepartmentIDEncrypt: x?.DepartmentIDEncrypt,
              DepartmentName: x?.DepartmentName,
              MaterialGroupIDEncrypt: x?.MaterialGroupIDEncrypt,
              MaterialGroupName: x?.MaterialGroupName,
              MaterialTypeIDEncrypt: x?.MaterialTypeIDEncrypt,
              MaterialType: x?.MaterialType,
              InwardIDEncrypted: x?.InwardIDEncrypt,
              TestMasterIDEncrypted: x?.TestMasterIDEncrypt,
              TestName: x?.TestName,
              TestingDate: x?.TestingDate,
              TestingToDate: x?.TestingToDate,
              TestingQty: x?.TestCount,
              LocationTypeName: x?.LocationTypeName,
              // TestMethodIDEncrypted: x?.TestMethodIDEncrypt,
              // TestMethodName: x?.TestMethod,
              MachineIDEncrypted: x?.MachineIDEncrypt,
              MachineName: x?.MachineName,
              ReferenceStandardIDEncrypted: x?.ReferenceStandardIDEncrypt,
              ReferenceStandardName: x?.ReferenceStandard,
              TestedByEmployeeNames: x?.TestedBy,
              Result: x?.Result,
              Remarks: x?.Remarks,
              TestingStatus: x?.TestingStatus,
              ChangeNote: x?.ChangeNote,
              btnStatus: 4,
              ApprovalNote: x?.ApprovalNote,
              ReferenceSubGroup: x?.ReferenceSubGroup,
              ParameterWith: x?.ParameterWith,
              ParameterWithName: x?.ParameterWithName,
              MergeSameValue: x?.MergeSameValue,
              BasedOnMeasurementValue: x?.BasedOnMeasurementValue,
              BasedOnHrsValue: x?.BasedOnHrsValue,
              // IsIncudeStandardRate: x?.IsIncudeStandardRate,
              IsMixDesign: x?.IsMixDesign,

              ListOfTestMasterImage: x?.ListOfTestMasterImage?.map((p) => ({
                TestingIDEncrypted: p?.TestingIDEncrypted,
                TestMasterImageIDEncrypted: p?.TestMasterImageIDEncrypted,
                ImageFilePath: p?.ImageFilePath,
                TestMasterIDEncrypted: p?.TestMasterIDEncrypted,
              })),
              ListOfTestingResultImages: x?.ListOfTestingResultImages?.map(
                (p) => ({
                  TestingResultImageIDEncrypted:
                    p?.TestingResultImageIDEncrypted,
                  TestingIDEncrypted: p?.TestingIDEncrypted,
                  ResultImagePath: p?.ResultImagePath,
                  Remarks: p?.Remarks,
                })
              ),

              ListOfParameter: x?.ListOfParameter?.map((p) => ({
                RefParameterIDEncrypted: p?.RefParameterIDEncrypted,
                ParameterName: p?.ParameterName,
                DisplayCode: p?.DisplayCode,
                IsNABLParameter: p?.IsNABLParameter,
                RangeValue: p?.RangeValue,
                MinValue: p?.MinValue,
                MaxValue: p?.MaxValue,
                NABLRangeFrom: p?.NABLRangeFrom,
                NABLRangeTo: p?.NABLRangeTo,
                Requirement: p?.Requirement,
                TestMethodIDEncrypt: p?.TestMethodIDEncrypt,
                TestMethod: p?.TestMethod,
                TestingResultList: p?.ListOfTestingResult?.map((r) => ({
                  TestingResultID: r?.TestingResultIDEncrypted,
                  TestingCount: r?.TestingCount,
                  TestingCountHeader: r?.TestingCountHeader,
                  ResultValue: r?.ResultValue,
                  ConsiderResult: r?.ConsiderResult,
                  ConsiderNABLResult: r?.ConsiderNABLResult,
                })),
                IsAverageRequired: p?.IsAverageRequired,
                AverageResultValue: p?.AverageResultValue,
                ParameterResultType: p?.ParameterResultType,
                ParameterType: p?.ParameterType,
                ShortCode: p?.ShortCode,
                FormulaExpression: p?.FormulaExpression,
              })),
              TestingRewiseAndRectifyActionStatus:
                x?.TestingRewiseAndRectifyActionStatus,
              TPIList: x?.TPIList,
              AllowTesting: x?.AllowTesting,
              ListOfDefineMoreRates: x?.ListOfDefineMoreRates,
              TestMixDesignDetail: x?.TestMixDesignDetail,
              TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData:
                x?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData,
              ListOfMixDesignTargetStrengthForMixProportioning:
                x?.ListOfMixDesignTargetStrengthForMixProportioning,
              ListOfMixDesignGroupParameters: x?.ListOfMixDesignGroupParameters,
              ListOfMixDesignMixCalculation: x?.ListOfMixDesignMixCalculation,
              ListOfMixDesignMixProportionsForTrial:
                x?.ListOfMixDesignMixProportionsForTrial,
            }))
          );
          formikApproval.setFieldValue(
            "ListOfLetterRefDoc",
            response?.ListOfLetterRefDoc?.map((x) => ({
              InwardLetterRefImageIDEncrypted:
                x?.InwardLetterRefImageIDEncrypted,
              InwardIDEncrypted: x?.InwardIDEncrypted,
              LetterRefImageFilePath: x?.LetterRefImageFilePath,
              LetterRefImageFileName: x?.LetterRefImageFileName,
            }))
          );
          formikApproval.setFieldValue(
            "IsTPIRequired",
            response?.IsTPIRequired
          );
          formikApproval.setFieldValue(
            "IsMaterialReturnable",
            response?.IsMaterialReturnable
          );
          formikApproval.setFieldValue("IsHold", response?.IsHold);

          setShowTestingApprovalModal(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (InwardMaterialID) {
      getTCDetailForTestingApproval(InwardMaterialID);
    }
  }, [InwardMaterialID]);

  const ApproveRejectTest = async (btnStatus, testIndex) => {
    if (
      btnStatus == 5 &&
      (!ListOfMaterialTests[testIndex]?.ApprovalNote ||
        ListOfMaterialTests[testIndex]?.ApprovalNote?.trim()?.length == 0)
    ) {
      return;
    } else {
      setIsLoading(true);

      let payload = {
        TestingIDEncrypted: ListOfMaterialTests[testIndex]?.TestingIDEncrypted,
        InwardMaterialIDEncrypted: InwardMaterialIDEncrypted,
        StatusRemarks: ListOfMaterialTests[testIndex]?.ApprovalNote?.trim(),
        TestingApprovalType: 1, //test wise
        TestingStatus: btnStatus,
        CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
      };

      await post(POST_TestingsApprovalInsert, payload)
        .then((response) => {
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              formikApproval.setFieldValue(
                `ListOfMaterialTests[${testIndex}].TestingStatus`,
                btnStatus
              );
              fnCallback();
            }, 500);
          } else {
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const ApproveRejectTCAllTest = async (btnStatus) => {
    if (
      btnStatus == 5 &&
      (!ApprovalNoteForApproveAll ||
        ApprovalNoteForApproveAll?.trim()?.length == 0)
    ) {
      formikApproval.setFieldError(
        "ApprovalNoteForApproveAll",
        "Approval Note is required!"
      );
      formikApproval.setFieldTouched("ApprovalNoteForApproveAll", true);
      return;
    } else {
      setIsLoading(true);

      let payload = {
        TestingIDEncrypted: "",
        InwardMaterialIDEncrypted: InwardMaterialIDEncrypted,
        StatusRemarks: ApprovalNoteForApproveAll?.trim(),
        TestingApprovalType: 2, //all test
        TestingStatus: btnStatus,
        CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
      };

      await post(POST_TestingsApprovalInsert, payload)
        .then((response) => {
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              setShowTCAllTestApprovalModal(false);
              setShowTestingApprovalModal(false);
              formikApproval.setFieldValue("ApprovalNoteForApproveAll", "");
              fnCallback();
            }, 500);
          } else {
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    setShowDefineMoreRatesModal(false);
  };

  return (
    <>
      <Modal
        className="fade"
        show={showTestingApprovalModal}
        onHide={setShowTestingApprovalModal}
        size={"xl"}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Testing Approval</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTestingApprovalModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <FormikProvider value={formikApproval}>
              <Form onSubmit={formikApproval.handleSubmit}>
                <Row>
                  <Col lg={5}>
                    {ListOfMaterialTests?.filter((x) => x?.TestingStatus == 3)
                      ?.length > 0 && (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-2"
                        title="Approve All"
                        onClick={() => setShowTCAllTestApprovalModal(true)}
                      >
                        {SVGICON.Verified}
                      </Link>
                    )}
                    <label className="mb-1">TC No:</label> &nbsp; {ApprovalTCNo}
                  </Col>
                  <Col lg={4}>
                    <label className="mb-1">Inward No:</label> &nbsp;{" "}
                    {ApprovalInwardNo} | {InwardDate}
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">EDD:</label> &nbsp; {EDD}
                  </Col>
                  {/* <Col lg={4}>
                    <label className="mb-1">Department:</label> &nbsp;{" "}
                    {DepartmentName}
                  </Col> */}
                  {/* <Col lg={5}>
                    <label className="mb-1">Material Group:</label> &nbsp;{" "}
                    {ProductGroupName}
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Material Type:</label> &nbsp;{" "}
                    {MaterialTypeName}
                  </Col> */}
                  <Col lg={12}>
                    <label className="mb-1">Sample Detail:</label> &nbsp;{" "}
                    {SampleDetail}
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Size:</label> &nbsp; {Size}
                  </Col>
                  <Col lg={7}>
                    <label className="mb-1">Condition:</label> &nbsp;{" "}
                    {Condition}
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Letter Ref No:</label> &nbsp;{" "}
                    {LetterRefNo} &nbsp;{" "}
                    {ListOfLetterRefDoc?.length > 0 ? (
                      <Link
                        to="#"
                        title="Letter Ref Doc"
                        className="text-primary"
                        onClick={() => {
                          setShowLetterRefDocModal(true);
                        }}
                      >
                        View File
                      </Link>
                    ) : (
                      ""
                    )}
                  </Col>
                  {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                    <Col lg={4}>
                      <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1 me-1 mb-1">
                        <label className="mb-1">Sample Returnable:</label>{" "}
                        &nbsp; {IsMaterialReturnable == true ? "Yes" : "No"}
                      </text>
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col lg={3}>
                    <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1 me-1 mb-1">
                      <label className="mb-1">TPI Required:</label> &nbsp;{" "}
                      {IsTPIRequired == true ? "Yes" : "No"}
                    </text>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Accordion className="accordion accordion-solid-bg">
                  {ListOfMaterialTests?.map((test, tIndex) => (
                    <Accordion.Item
                      className="accordion-item"
                      key={tIndex}
                      eventKey={tIndex}
                    >
                      <Accordion.Header
                        className="accordion-header rounded-lg"
                        style={{
                          backgroundColor:
                            test.TestingStatus == 1
                              ? "#ed7c79"
                              : test.TestingStatus == 2
                              ? "#80c9ff"
                              : test.TestingStatus == 3
                              ? "#4aa493"
                              : test.TestingStatus == 4
                              ? "#419841"
                              : test.TestingStatus == 5
                              ? "#f79f50"
                              : "",
                          color: "#fff",
                        }}
                      >
                        {test.TestName}
                      </Accordion.Header>
                      <Accordion.Collapse eventKey={tIndex}>
                        <div className="accordion-body">
                          <Row>
                            <Col lg={5}>
                              <label>Test Name:</label> &nbsp; {test.TestName}
                            </Col>
                            {test.TestingStatus != 1 &&
                              test.TestingStatus != 2 && (
                                <>
                                  <Col lg={4}>
                                    <label>Test Date:</label> &nbsp;{" "}
                                    {test.TestingDate == test.TestingToDate
                                      ? test.TestingDate
                                      : test.TestingDate +
                                        " to " +
                                        test.TestingToDate}
                                  </Col>
                                  <Col lg={3}>
                                    <label>Testing Qty:</label> &nbsp;{" "}
                                    {test.TestingQty}
                                  </Col>
                                  <Col lg={5}>
                                    <label>Department:</label> &nbsp;{" "}
                                    {test.DepartmentName}
                                  </Col>
                                  <Col lg={4}>
                                    <label className="mb-1">
                                      Material Group:
                                    </label>{" "}
                                    &nbsp; {test.MaterialGroupName}
                                  </Col>
                                  <Col lg={3}>
                                    <label className="mb-1">
                                      Material Type:
                                    </label>{" "}
                                    &nbsp; {test.MaterialType}
                                  </Col>
                                  {/* <Col lg={5}>
                                    <label>Test Method:</label> &nbsp;{" "}
                                    {test.TestMethodName}
                                  </Col> */}
                                  <Col lg={5}>
                                    <label>Reference Standard:</label> &nbsp;{" "}
                                    {test.ReferenceStandardName}
                                  </Col>
                                  <Col lg={4}>
                                    <label>Machine:</label> &nbsp;{" "}
                                    {test.MachineName}
                                  </Col>
                                  <Col lg={3}>
                                    <label>Location:</label> &nbsp;
                                    {test.LocationTypeName}
                                  </Col>

                                  <Col lg={5}>
                                    <label>Test Master Image:</label> &nbsp;{" "}
                                    {test.ListOfTestMasterImage?.length > 0 ? (
                                      <Link
                                        to="#"
                                        className="text-primary"
                                        onClick={() => {
                                          setListTestMasterImages("");
                                          setShowTestMasterImagesModal(true);
                                          setListTestMasterImages(
                                            test.ListOfTestMasterImage
                                          );
                                        }}
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                  <Col lg={4}>
                                    <label>Testing Result Image:</label> &nbsp;{" "}
                                    {test?.ListOfTestingResultImages?.length >
                                    0 ? (
                                      <Link
                                        to="#"
                                        className="text-primary"
                                        onClick={() => {
                                          setListOfTestingResultImages("");
                                          setShowTestingResultImagesModal(true);
                                          setListOfTestingResultImages(
                                            test.ListOfTestingResultImages
                                          );
                                        }}
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                  <Col lg={3}>
                                    {IsTPIRequired == true && (
                                      <>
                                        <label>TPI Details:</label> &nbsp;{" "}
                                        {test?.TPIList?.length > 0 ? (
                                          <Link
                                            to="#"
                                            className="text-primary"
                                            onClick={() => {
                                              setListOfTPIDetails(test.TPIList);
                                              setShowTPIDetailModal(true);
                                            }}
                                          >
                                            View
                                          </Link>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    )}
                                  </Col>
                                  <Col lg={5}>
                                    <label>Tested By:</label> &nbsp;{" "}
                                    {test.TestedByEmployeeNames}
                                  </Col>
                                  {AuthUser?.Permissions?.Account == 1 ? (
                                    test?.ListOfDefineMoreRates?.length > 0 ? (
                                      <Col lg={4}>
                                        <label>Define More Rates:</label> &nbsp;{" "}
                                        <Link
                                          to="#"
                                          className="m-2 text-primary"
                                          title="View Define More Rates"
                                          onClick={() => {
                                            formikDefineMoreRates.setFieldValue(
                                              "MoreTestRatesList",
                                              test?.ListOfDefineMoreRates
                                            );
                                            setShowDefineMoreRatesModal(true);
                                          }}
                                        >
                                          View
                                        </Link>
                                      </Col>
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  )}
                                  {test.BasedOnMeasurementValue ? (
                                    <Col lg={3}>
                                      <label>Based On Measurement Value:</label>{" "}
                                      &nbsp; {test.BasedOnMeasurementValue}
                                    </Col>
                                  ) : (
                                    ""
                                  )}
                                  {test.BasedOnHrsValue ? (
                                    <Col lg={3}>
                                      <label>Based On Hrs Value:</label> &nbsp;{" "}
                                      {test.BasedOnHrsValue}
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  <Col lg={12}>
                                    <label>Result:</label> &nbsp; {test.Result}
                                  </Col>
                                  <Col lg={12}>
                                    <label>Remarks:</label> &nbsp;{" "}
                                    {test.Remarks}
                                  </Col>
                                </>
                              )}
                            {test.TestingStatus != 3 && (
                              <>
                                <Col lg={6}>
                                  <label>Testing Status:</label> &nbsp;
                                  <b>
                                    {test.TestingStatus == 1
                                      ? "Pending"
                                      : test.TestingStatus == 2
                                      ? "Draft"
                                      : test.TestingStatus == 4
                                      ? "Approved"
                                      : test.TestingStatus == 5
                                      ? "Revise & Rectify"
                                      : ""}
                                  </b>
                                </Col>
                                <Col lg={6}>
                                  {test.ApprovalNote ? (
                                    <>
                                      <label>Approval Note:</label>&nbsp;
                                      {test.ApprovalNote}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Col>
                              </>
                            )}
                          </Row>
                          <hr className="mt-0 mb-2"></hr>
                          {(test.TestingStatus == 3 ||
                            (test.TestingStatus == 4 &&
                              test.TestingRewiseAndRectifyActionStatus ==
                                true)) && (
                            <>
                              <Row>
                                <Col lg={6}>
                                  <Field
                                    type="text"
                                    name={`ListOfMaterialTests[${tIndex}].ApprovalNote`}
                                    component={CustomInput}
                                    placeholder="Approval Note"
                                    maxLength={100}
                                    required={test.btnStatus == 5} //required when Revise & Rectify
                                  />
                                  {test.btnStatus == 5 &&
                                    (!test?.ApprovalNote ||
                                      test?.ApprovalNote?.trim().length ==
                                        0) && (
                                      <div
                                        className="invalid-feedback animated fadeInUp"
                                        style={{
                                          display: "block",
                                          marginTop: "-10px",
                                        }}
                                      >
                                        Approval Note is required!
                                      </div>
                                    )}
                                </Col>
                                <Col lg={6}>
                                  {test.TestingStatus == 3 && (
                                    <button
                                      type="button"
                                      // className="btn btn-primary"
                                      className="btn btn-primary btn-sm me-2"
                                      onClick={() => {
                                        formikApproval.setFieldValue(
                                          `ListOfMaterialTests[${tIndex}].btnStatus`,
                                          4
                                        );
                                        ApproveRejectTest(4, tIndex);
                                      }}
                                    >
                                      <i className="fa fa-circle-check"></i>{" "}
                                      Approve
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    // className="btn btn-danger light"
                                    className="btn btn-primary btn-sm"
                                    onClick={(e) => {
                                      formikApproval.setFieldValue(
                                        `ListOfMaterialTests[${tIndex}].btnStatus`,
                                        5
                                      );
                                      ApproveRejectTest(5, tIndex);
                                    }}
                                  >
                                    <i className="fa fa-rotate-left"></i> Revise
                                    & Rectify
                                  </button>
                                  <Link
                                    to={
                                      (AuthUser?.UserType !== 1 ||
                                        formsList?.filter(
                                          (x) =>
                                            x?.FormID == 33 &&
                                            (x?.IsAdd || x?.IsEdit)
                                        )?.length > 0) &&
                                      test?.AllowTesting == true &&
                                      IsHold == false
                                        ? `/testing/${window.btoa(
                                            test.InwardMaterialIDEncrypted
                                          )}/${window.btoa(
                                            test.InwardMaterialTestDetailIDEncrypted
                                          )}`
                                        : "#"
                                    }
                                    className="btn btn-primary btn-sm ms-2"
                                    title="Edit"
                                  >
                                    <i className="fa fa-pencil"></i> Edit
                                  </Link>
                                </Col>
                              </Row>
                              <hr className="mt-0 mb-1"></hr>
                            </>
                          )}
                          {test.TestingStatus != 1 &&
                            test.TestingStatus != 2 && (
                              <>
                                {test.IsMixDesign == true && (
                                  <>
                                    <Row>
                                      <Col lg={12}>
                                        <div className="d-flex justify-content-between mb-0">
                                          <div className="d-flex mb-0">
                                            <label>
                                              Mix Design (STIPULATIONS FOR
                                              PROPORTIONING)
                                            </label>
                                          </div>
                                        </div>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.GradeDesignation`}
                                                  label={"Grade Designation"}
                                                  placeholder={
                                                    "Grade Designation"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Type of Cement"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.TypeofCementName`}
                                                  placeholder={"Type of Cement"}
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <div className="mb-2">
                                                  <label className="mb-1">
                                                    Method of Concrete Placing
                                                    &nbsp;
                                                  </label>
                                                  <div className="form-control form-control-sm">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      id={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                                                      name={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                                                      checked={
                                                        test
                                                          ?.TestMixDesignDetail
                                                          ?.MethodofConcretePlacingIsChute_NonPumpable
                                                      }
                                                      disabled={true}
                                                    />
                                                    <label className="mb-1 ms-1 me-2 mt-1">
                                                      Chute (Non pumpable)
                                                      &nbsp;
                                                    </label>
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      id={`chkMethodofConcretePlacingIsPumping`}
                                                      name={`chkMethodofConcretePlacingIsPumping`}
                                                      checked={
                                                        test
                                                          ?.TestMixDesignDetail
                                                          ?.MethodofConcretePlacingIsPumping
                                                      }
                                                      disabled={true}
                                                    />
                                                    <label className="mb-1 ms-1 mt-1">
                                                      Pumping &nbsp;
                                                    </label>
                                                  </div>
                                                </div>
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Type of Mineral Admixture"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.TypeofMineralAdmixtureName`}
                                                  placeholder={
                                                    "Type of Mineral Admixture"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.DegreeofSiteControl`}
                                                  label={
                                                    "Degree of Site Control"
                                                  }
                                                  placeholder={
                                                    "Degree of Site Control"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Maximum Nominal Size of Aggregate"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.MaximumNominalSizeofAggregateName`}
                                                  placeholder={
                                                    "Maximum Nominal Size of Aggregate"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.TypeofAggregateFineCoarse`}
                                                  label={
                                                    "Type of Aggregate Coarse"
                                                  }
                                                  placeholder={
                                                    "Type of Aggregate Coarse"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Type of Aggregate Fine"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.TypeofAggregateFineName`}
                                                  placeholder={
                                                    "Type of Aggregate Fine"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Environmental Exposure Conditions"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.EnvironmentalExposureConditionsName`}
                                                  placeholder={
                                                    "Environmental Exposure Conditions"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  type="number"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.MaximumCementContent`}
                                                  label={
                                                    "Maximum Cement Content (kg/m3)"
                                                  }
                                                  placeholder={
                                                    "Maximum Cement Content (kg/m3)"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  type="number"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.MinimumCementContent`}
                                                  label={
                                                    "Minimum Cement Content (kg/m3)"
                                                  }
                                                  placeholder={
                                                    "Minimum Cement Content (kg/m3)"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  type="number"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.MaximumWaterCementRatio`}
                                                  label={
                                                    "Maximum Water Cement Ratio"
                                                  }
                                                  placeholder={
                                                    "Maximum Water Cement Ratio"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.Workability`}
                                                  label={"Workability"}
                                                  placeholder={"Workability"}
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Chemical Admixture Type"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.ChemicalAdmixtureTypeName`}
                                                  placeholder={
                                                    "Chemical Admixture Type"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Chemical Admixture Brand/Batch/ID Mark"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.ChemicalAdmixtureBrandBatchandMarkName`}
                                                  placeholder={
                                                    "Chemical Admixture Brand/Batch/ID Mark"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.TransportationTime`}
                                                  label={"Transportation Time"}
                                                  placeholder={"hh:mm"}
                                                  component={CustomFlatpickr}
                                                  options={{
                                                    enableTime: true,
                                                    noCalendar: true,
                                                    dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                                                    time_24hr: true, // Enforces 24-hour format
                                                    //allowInput: true, // Allows typing
                                                    minuteIncrement: 1, // Allows setting minutes with up/down arrows
                                                  }}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.RetentionTime`}
                                                  label={"Retention Time"}
                                                  placeholder={"hh:mm"}
                                                  component={CustomFlatpickr}
                                                  options={{
                                                    enableTime: true,
                                                    noCalendar: true,
                                                    dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                                                    time_24hr: true, // Enforces 24-hour format
                                                    //allowInput: true, // Allows typing
                                                    minuteIncrement: 1, // Allows setting minutes with up/down arrows
                                                  }}
                                                  disabled={true}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                  </>
                                )}
                                <Row>
                                  <div className="d-flex justify-content-between mb-0">
                                    <div className="d-flex mb-0">
                                      <label>Testing Parameters</label>
                                    </div>
                                  </div>
                                  <Col lg={12}>
                                    <div
                                      className="card mb-0"
                                      style={{ height: "auto" }}
                                    >
                                      <div className="card-body p-2">
                                        <Row>
                                          {test.ReferenceStandardIDEncrypted &&
                                          test?.ReferenceSubGroup ? (
                                            <Col
                                              lg={2}
                                              style={{ marginTop: "-5px" }}
                                            >
                                              <Field
                                                type="text"
                                                label="Group"
                                                name={`ListOfMaterialTests[${tIndex}].ReferenceSubGroup`}
                                                component={CustomInput}
                                                placeholder="Reference Sub Group"
                                                // noMarginBottom={true}
                                                disabled={true}
                                              />
                                            </Col>
                                          ) : (
                                            ""
                                          )}
                                          <Col
                                            lg={2}
                                            style={{ width: "125px" }}
                                          >
                                            <div className="form-check custom-checkbox mb-2 form-check-inline ms-1 mt-3">
                                              <input
                                                type="radio"
                                                className="form-check-input"
                                                id="None"
                                                name={`ParameterWith${tIndex}`}
                                                title="None"
                                                style={{ cursor: "pointer" }}
                                                checked={
                                                  test.ParameterWith == 1
                                                }
                                                disabled={true}
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="None"
                                              >
                                                None
                                              </label>
                                            </div>
                                          </Col>
                                          {test.ReferenceStandardIDEncrypted && (
                                            <Col lg={2}>
                                              <div className="form-check custom-checkbox mb-2 form-check-inline ms-1 mt-3">
                                                <input
                                                  type="radio"
                                                  className="form-check-input"
                                                  id="PrintMinMax"
                                                  name={`ParameterWith${tIndex}`}
                                                  title="Print Min-Max"
                                                  style={{ cursor: "pointer" }}
                                                  checked={
                                                    test.ParameterWith == 2
                                                  }
                                                  disabled={true}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="PrintMinMax"
                                                >
                                                  Print Min/Max
                                                </label>
                                              </div>
                                            </Col>
                                          )}
                                          {test.IsMixDesign == false && (
                                            <Col lg={3}>
                                              <div className="form-check custom-checkbox mb-2 form-check-inline ms-1 mt-3">
                                                <input
                                                  type="radio"
                                                  className="form-check-input"
                                                  id="PrintRequirement"
                                                  name={`ParameterWith${tIndex}`}
                                                  title="Print Requirement"
                                                  style={{ cursor: "pointer" }}
                                                  checked={
                                                    test.ParameterWith == 3
                                                  }
                                                  disabled={true}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="PrintRequirement"
                                                >
                                                  Print Requirement
                                                </label>
                                              </div>
                                            </Col>
                                          )}
                                          <Col lg={3}>
                                            <div className="d-flex mb-2 mt-3">
                                              <label
                                                className="mb-1"
                                                style={{ opacity: "0.5" }}
                                              >
                                                Merge Same Value &nbsp;
                                              </label>
                                              <div className="form-check form-switch">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  role="switch"
                                                  id="flexSwitchCheckIsMergeSameValue"
                                                  title={
                                                    test.MergeSameValue == true
                                                      ? "Yes"
                                                      : "No"
                                                  }
                                                  checked={test.MergeSameValue}
                                                  disabled={true}
                                                  style={{ cursor: "pointer" }}
                                                ></input>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <hr className="mt-0 mb-1"></hr>
                                        <Row>
                                          <Col lg={12}>
                                            <div>
                                              <Row>
                                                {test.ReferenceStandardIDEncrypted && (
                                                  <Col lg={5}>
                                                    <div className="d-flex ">
                                                      <div
                                                        style={{
                                                          width: "170px",
                                                        }}
                                                      >
                                                        <label>
                                                          Ref. Standard
                                                          Indication :
                                                        </label>
                                                      </div>
                                                      <div>
                                                        <i
                                                          className="fa fa-circle"
                                                          style={{
                                                            color: "green",
                                                          }}
                                                        ></i>
                                                        &nbsp; Valid
                                                        &nbsp;&nbsp;
                                                        <i
                                                          className="fa fa-circle"
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        ></i>
                                                        &nbsp; Invalid
                                                        &nbsp;&nbsp;
                                                        <i
                                                          className="fa fa-circle"
                                                          style={{
                                                            color: "orange",
                                                          }}
                                                        ></i>
                                                        &nbsp; Unidentified
                                                      </div>
                                                    </div>
                                                  </Col>
                                                )}
                                                <Col lg={5}>
                                                  <div className="d-flex ">
                                                    <div
                                                      style={{ width: "160px" }}
                                                    >
                                                      <label>
                                                        NABL Range Indication :
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <i
                                                        className="fa fa-certificate"
                                                        style={{
                                                          color: "green",
                                                        }}
                                                      ></i>
                                                      &nbsp; Valid &nbsp;&nbsp;
                                                      <i
                                                        className="fa fa-certificate"
                                                        style={{ color: "red" }}
                                                      ></i>
                                                      &nbsp; Invalid
                                                      &nbsp;&nbsp;
                                                      <i
                                                        className="fa fa-certificate"
                                                        style={{
                                                          color: "orange",
                                                        }}
                                                      ></i>
                                                      &nbsp; Unidentified
                                                    </div>
                                                  </div>
                                                </Col>
                                                <Col lg={5}>
                                                  <div className="d-flex ">
                                                    <div
                                                      style={{ width: "160px" }}
                                                    >
                                                      <label>
                                                        Parameter Result Type :
                                                      </label>
                                                    </div>
                                                    <div>
                                                      &nbsp; QN - Quantitative
                                                      &nbsp;&nbsp; &nbsp; QL -
                                                      Qualitative &nbsp;
                                                    </div>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>
                                            <div className="table-responsive active-projects style-1 shorting mb-2">
                                              <div
                                                id="ParameterDetail-tbl_wrapper"
                                                className="dataTables_wrapper table-responsive no-footer"
                                              >
                                                <table
                                                  id="ParameterDetail-tbl"
                                                  className="table table-bordered no-footer mb-0"
                                                >
                                                  <thead>
                                                    <tr>
                                                      {/* <th width="16%">Code</th> */}
                                                      <th width="16%">
                                                        Parameter
                                                      </th>
                                                      <th width="16%">
                                                        Test Method
                                                      </th>
                                                      {test.ReferenceStandardIDEncrypted && (
                                                        <th width="15%">
                                                          Range
                                                        </th>
                                                      )}
                                                      {test.ParameterWith ==
                                                        2 && (
                                                        <>
                                                          <th width="9%">
                                                            Min
                                                          </th>
                                                          <th width="9%">
                                                            Max
                                                          </th>
                                                        </>
                                                      )}
                                                      {/* {test.ParameterWith ==
                                                      3 && (
                                                      <th width="15%">
                                                        Requirement
                                                      </th>
                                                    )} */}
                                                      {test.IsMixDesign ==
                                                      true ? (
                                                        <th width="15%">
                                                          Printing Group
                                                        </th>
                                                      ) : (
                                                        test.ParameterWith ==
                                                          3 && (
                                                          <th width="15%">
                                                            Requirement
                                                          </th>
                                                        )
                                                      )}
                                                      <th width="5%">NABL</th>
                                                      {test.ListOfParameter[0]?.TestingResultList?.map(
                                                        (result, rIdx) => (
                                                          <th
                                                            width="15%"
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            {test
                                                              .ListOfParameter[0]
                                                              ?.TestingResultList
                                                              ?.length > 1
                                                              ? result.TestingCountHeader
                                                                ? result.TestingCountHeader
                                                                : "S" +
                                                                  result.TestingCount
                                                              : "Value"}
                                                          </th>
                                                        )
                                                      )}
                                                      {parseInt(
                                                        test.TestingQty
                                                      ) > 1 ? (
                                                        test.ListOfParameter?.filter(
                                                          (x) =>
                                                            x.IsAverageRequired ==
                                                            true
                                                        )?.length > 0 ? (
                                                          <th
                                                            width="5%"
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            Average
                                                          </th>
                                                        ) : (
                                                          ""
                                                        )
                                                      ) : (
                                                        ""
                                                      )}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {test.ListOfParameter
                                                      ?.length > 0 ? (
                                                      test.ListOfParameter?.map(
                                                        (para, pIndex) => (
                                                          <tr key={pIndex}>
                                                            {/* <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {para.DisplayCode}
                                                          </td> */}
                                                            <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth:
                                                                  "100px",
                                                              }}
                                                            >
                                                              {
                                                                para.ParameterName
                                                              }
                                                              {para.ShortCode ? (
                                                                <>
                                                                  &nbsp;(
                                                                  <span className="text-primary">
                                                                    <b>
                                                                      {
                                                                        para.ShortCode
                                                                      }
                                                                    </b>
                                                                  </span>
                                                                  )
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                              {para.FormulaExpression ? (
                                                                <>
                                                                  &nbsp;
                                                                  <i
                                                                    className="custom-fa"
                                                                    title={
                                                                      para.FormulaExpression
                                                                    }
                                                                  >
                                                                    &#x0192;x
                                                                  </i>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
                                                            <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth:
                                                                  "100px",
                                                              }}
                                                            >
                                                              {para.TestMethod}
                                                            </td>
                                                            {test.ReferenceStandardIDEncrypted && (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "100px",
                                                                }}
                                                              >
                                                                {para?.RangeValue && (
                                                                  <Field
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfParameter[${pIndex}].RangeValue`}
                                                                    placeholder={
                                                                      "Range Value"
                                                                    }
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                            )}

                                                            {test.ParameterWith ==
                                                              2 && (
                                                              <>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "80px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    type="number"
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfParameter[${pIndex}].MinValue`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    placeholder="Min"
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "80px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    type="number"
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfParameter[${pIndex}].MaxValue`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    placeholder="Max"
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                </td>
                                                              </>
                                                            )}
                                                            {/* {test.ParameterWith ==
                                                            3 && (
                                                            <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth:
                                                                  "100px",
                                                              }}
                                                            >
                                                              <Field
                                                                type="text"
                                                                name={`ListOfMaterialTests[${tIndex}].ListOfParameter[${pIndex}].Requirement`}
                                                                component={
                                                                  CustomInput
                                                                }
                                                                placeholder="Requirement"
                                                                maxLength={500}
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                disabled={true}
                                                              />
                                                            </td>
                                                          )} */}
                                                            {test.IsMixDesign ==
                                                            true ? (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "100px",
                                                                }}
                                                              >
                                                                <label>
                                                                  {
                                                                    para.Requirement
                                                                  }
                                                                </label>
                                                              </td>
                                                            ) : (
                                                              test.ParameterWith ==
                                                                3 && (
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "100px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    type="text"
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfParameter[${pIndex}].Requirement`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    placeholder="Requirement"
                                                                    maxLength={
                                                                      500
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                </td>
                                                              )
                                                            )}
                                                            <td>
                                                              <label
                                                                title={
                                                                  para.NABLRangeFrom
                                                                    ? para.NABLRangeFrom +
                                                                      " - " +
                                                                      para.NABLRangeTo
                                                                    : ""
                                                                }
                                                              >
                                                                {para.IsNABLParameter
                                                                  ? "Yes"
                                                                  : "No"}
                                                                &nbsp;
                                                                {para?.ParameterType ==
                                                                1
                                                                  ? para?.ParameterResultType ==
                                                                    2
                                                                    ? "(QL)"
                                                                    : "(QN)"
                                                                  : ""}
                                                              </label>
                                                            </td>
                                                            {para?.TestingResultList?.map(
                                                              (
                                                                result,
                                                                rIdx
                                                              ) => (
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                    minWidth:
                                                                      "100px",
                                                                  }}
                                                                >
                                                                  <div className="d-flex justify-content-between">
                                                                    <div
                                                                      className="pe-1"
                                                                      style={{
                                                                        width:
                                                                          "90%",
                                                                      }}
                                                                    >
                                                                      <Field
                                                                        type="text"
                                                                        name={`ListOfMaterialTests[${tIndex}].ListOfParameter[${pIndex}].TestingResultList[${rIdx}].ResultValue`}
                                                                        component={
                                                                          CustomInput
                                                                        }
                                                                        placeholder="Value"
                                                                        maxLength={
                                                                          500
                                                                        }
                                                                        noMarginBottom={
                                                                          true
                                                                        }
                                                                        disabled={
                                                                          true
                                                                        }
                                                                      />
                                                                    </div>
                                                                    <div
                                                                      style={{
                                                                        alignContent:
                                                                          "center",
                                                                      }}
                                                                    >
                                                                      {test.ReferenceStandardIDEncrypted && (
                                                                        <>
                                                                          {result?.ConsiderResult ==
                                                                          0 ? (
                                                                            <i
                                                                              className="fa fa-circle"
                                                                              style={{
                                                                                color:
                                                                                  "red",
                                                                              }}
                                                                            ></i>
                                                                          ) : result.ConsiderResult ==
                                                                            1 ? (
                                                                            <i
                                                                              className="fa fa-circle"
                                                                              style={{
                                                                                color:
                                                                                  "green",
                                                                              }}
                                                                            ></i>
                                                                          ) : result.ConsiderResult ==
                                                                            -1 ? (
                                                                            <i
                                                                              className="fa fa-circle"
                                                                              style={{
                                                                                color:
                                                                                  "orange",
                                                                              }}
                                                                            ></i>
                                                                          ) : (
                                                                            <i className="fa fa-circle"></i>
                                                                          )}
                                                                          <br></br>
                                                                        </>
                                                                      )}
                                                                      {para?.IsNABLParameter ==
                                                                      true ? (
                                                                        <>
                                                                          {result?.ConsiderNABLResult ==
                                                                          0 ? (
                                                                            <i
                                                                              className="fa fa-certificate"
                                                                              style={{
                                                                                color:
                                                                                  "red",
                                                                              }}
                                                                            ></i>
                                                                          ) : result.ConsiderNABLResult ==
                                                                            1 ? (
                                                                            <i
                                                                              className="fa fa-certificate"
                                                                              style={{
                                                                                color:
                                                                                  "green",
                                                                              }}
                                                                            ></i>
                                                                          ) : result.ConsiderNABLResult ==
                                                                            -1 ? (
                                                                            <i
                                                                              className="fa fa-certificate"
                                                                              style={{
                                                                                color:
                                                                                  "orange",
                                                                              }}
                                                                            ></i>
                                                                          ) : (
                                                                            <i className="fa fa-certificate"></i>
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </td>
                                                              )
                                                            )}
                                                            {parseInt(
                                                              test.TestingQty
                                                            ) > 1 ? (
                                                              test.ListOfParameter?.filter(
                                                                (x) =>
                                                                  x.IsAverageRequired ==
                                                                  true
                                                              )?.length > 0 ? (
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                    minWidth:
                                                                      "80px",
                                                                  }}
                                                                >
                                                                  {para.IsAverageRequired ==
                                                                    true && (
                                                                    <Field
                                                                      type="text"
                                                                      name={`ListOfMaterialTests[${tIndex}].ListOfParameter[${pIndex}].AverageResultValue`}
                                                                      component={
                                                                        CustomInput
                                                                      }
                                                                      placeholder="Average"
                                                                      maxLength={
                                                                        50
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                      noMarginBottom={
                                                                        true
                                                                      }
                                                                    />
                                                                  )}
                                                                </td>
                                                              ) : (
                                                                ""
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </tr>
                                                        )
                                                      )
                                                    ) : (
                                                      <tr>
                                                        <td
                                                          colSpan={8}
                                                          style={{
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          <div>
                                                            {
                                                              "No Record Found..."
                                                            }
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                                {test.IsMixDesign == true && (
                                  <>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>Sieve Analysis</label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <label className="mb-0">
                                                  1 - Coarse Aggregate
                                                </label>
                                              </Col>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-0">
                                                  <div
                                                    id="mixDesignCourseAggRefStdParameterCriteria-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="mixDesignCourseAggRefStdParameterCriteria-tbl"
                                                      className="table table-bordered no-footer mb-2"
                                                    >
                                                      <thead>
                                                        <tr key={0}>
                                                          <th
                                                            className="text-center"
                                                            rowSpan="3"
                                                          >
                                                            IS Sieve Size{" "}
                                                            <br></br>mm
                                                          </th>
                                                          {test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                                            test
                                                              ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                              ?.SieveSizeList
                                                              ?.length > 0 &&
                                                            test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                              (p, pIdx) => (
                                                                <th
                                                                  className="text-center"
                                                                  rowSpan={
                                                                    p
                                                                      ?.CriateriaList
                                                                      .length >
                                                                    0
                                                                      ? p?.CriateriaList.filter(
                                                                          (x) =>
                                                                            x.IsInputColumn ==
                                                                            true
                                                                        )
                                                                          .length >
                                                                        0
                                                                        ? 1
                                                                        : 2
                                                                      : 3
                                                                  }
                                                                  colSpan={
                                                                    p
                                                                      ?.CriateriaList
                                                                      .length >
                                                                    0
                                                                      ? p
                                                                          ?.CriateriaList
                                                                          .length
                                                                      : 1
                                                                  }
                                                                  style={{
                                                                    whiteSpace:
                                                                      "normal",
                                                                  }}
                                                                >
                                                                  {
                                                                    p?.ParameterColumnName
                                                                  }
                                                                </th>
                                                              )
                                                            )}
                                                        </tr>
                                                        <tr key={1}>
                                                          {test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                                            test
                                                              ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                              ?.SieveSizeList
                                                              ?.length > 0 &&
                                                            test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                              (p, pIdx) =>
                                                                p?.CriateriaList?.filter(
                                                                  (x) =>
                                                                    x.IsInputColumn ==
                                                                    true
                                                                ).map(
                                                                  (c, cIdx) => (
                                                                    <th
                                                                      className="text-center"
                                                                      style={{
                                                                        whiteSpace:
                                                                          "normal",
                                                                      }}
                                                                    >
                                                                      {
                                                                        c?.ParameterCriteria
                                                                      }
                                                                      <br></br>
                                                                      <span
                                                                        style={{
                                                                          fontSize:
                                                                            "10px",
                                                                        }}
                                                                      >
                                                                        {c?.ColumnShortCode
                                                                          ? `(Short Code: ${c?.ColumnShortCode})`
                                                                          : ""}
                                                                      </span>
                                                                    </th>
                                                                  )
                                                                )
                                                            )}
                                                        </tr>
                                                        <tr key={2}>
                                                          {test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                                            test
                                                              ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                              ?.SieveSizeList
                                                              ?.length > 0 &&
                                                            test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                              (p, pIdx) =>
                                                                p?.CriateriaList?.map(
                                                                  (c, cIdx) => (
                                                                    <th
                                                                      className="text-center"
                                                                      style={{
                                                                        whiteSpace:
                                                                          "normal",
                                                                      }}
                                                                    >
                                                                      {c?.IsInputColumn ==
                                                                      true ? (
                                                                        <div className="d-flex">
                                                                          {c?.IsInputColumnValueType ==
                                                                            true && (
                                                                            <>
                                                                              {/* <span className="mt-2 mb-1 me-1">
                                                                                {
                                                                                  c.ColumnShortCode
                                                                                }
                                                                                {`${
                                                                                  c.ColumnShortCode
                                                                                    ? "X"
                                                                                    : ""
                                                                                }`}
                                                                              </span> */}
                                                                              <Field
                                                                                style={{
                                                                                  minWidth:
                                                                                    "50px",
                                                                                }}
                                                                                type="number"
                                                                                name={`ListOfMaterialTests[${tIndex}].TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0].ParameterList[${pIdx}].CriateriaList[${cIdx}].InputColumnValueofX`}
                                                                                placeholder="Value"
                                                                                component={
                                                                                  CustomInput
                                                                                }
                                                                                noMarginBottom={
                                                                                  true
                                                                                }
                                                                                disabled={
                                                                                  true
                                                                                }
                                                                              />
                                                                            </>
                                                                          )}
                                                                          <Field
                                                                            style={{
                                                                              minWidth:
                                                                                c?.IsInputColumnValueType ==
                                                                                true
                                                                                  ? "50px"
                                                                                  : "100px",
                                                                            }}
                                                                            type="text"
                                                                            name={`ListOfMaterialTests[${tIndex}].TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0].ParameterList[${pIdx}].CriateriaList[${cIdx}].InputColumnName`}
                                                                            component={
                                                                              CustomInput
                                                                            }
                                                                            noMarginBottom={
                                                                              true
                                                                            }
                                                                            placeholder={
                                                                              c?.IsInputColumnValueType ==
                                                                              true
                                                                                ? "Prefix"
                                                                                : "Column Name"
                                                                            }
                                                                            disabled={
                                                                              true
                                                                            }
                                                                          />
                                                                        </div>
                                                                      ) : (
                                                                        c?.ParameterCriteria
                                                                      )}
                                                                    </th>
                                                                  )
                                                                )
                                                            )}
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                                          test
                                                            ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                            ?.SieveSizeList
                                                            ?.length > 0 &&
                                                          test?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList?.map(
                                                            (s, sIdx) => (
                                                              <tr>
                                                                <td className="text-center">
                                                                  {s?.SieveSize}
                                                                </td>
                                                                {s?.ParameterList.map(
                                                                  (p, pIdx) =>
                                                                    p?.CriateriaList.map(
                                                                      (
                                                                        c,
                                                                        cIdx
                                                                      ) => (
                                                                        <td className="text-center">
                                                                          {c?.IsInputColumn ==
                                                                          true ? (
                                                                            <Field
                                                                              type="text"
                                                                              name={`ListOfMaterialTests[${tIndex}].TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[${sIdx}].ParameterList[${pIdx}].CriateriaList[${cIdx}].ColumnValue`}
                                                                              component={
                                                                                CustomInput
                                                                              }
                                                                              noMarginBottom={
                                                                                true
                                                                              }
                                                                              disabled={
                                                                                true
                                                                              }
                                                                            />
                                                                          ) : c?.ColumnValue ? (
                                                                            c.ColumnValue
                                                                          ) : (
                                                                            "-"
                                                                          )}
                                                                        </td>
                                                                      )
                                                                    )
                                                                )}
                                                              </tr>
                                                            )
                                                          )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <label className="mb-0">
                                                  2 - Fine Aggregate
                                                </label>
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Conforming To grading Zone"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.FineAggregateConformingToGradingZone`}
                                                  placeholder={
                                                    "Conforming to grading Zone"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Reference Standard Table"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.FineAggregateReferenceStandardAndTableName`}
                                                  placeholder={
                                                    "Reference Standard Table"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>
                                            A-3 TARGET STRENGTH FOR MIX
                                            PROPORTIONING
                                          </label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-0">
                                                  <div
                                                    id="mixDesignCourseAggRefStdParameterCriteria-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="mixDesignCourseAggRefStdParameterCriteria-tbl"
                                                      className="table table-bordered no-footer mb-2"
                                                    >
                                                      <tbody>
                                                        {Object.entries(
                                                          test?.ListOfMixDesignTargetStrengthForMixProportioning?.reduce(
                                                            (
                                                              acc,
                                                              item,
                                                              index
                                                            ) => {
                                                              if (
                                                                !acc[
                                                                  item.Formula
                                                                ]
                                                              ) {
                                                                acc[
                                                                  item.Formula
                                                                ] = [];
                                                              }
                                                              acc[
                                                                item.Formula
                                                              ].push({
                                                                ...item,
                                                                originalIndex:
                                                                  index,
                                                              }); // Add the original index
                                                              return acc;
                                                            },
                                                            {}
                                                          )
                                                        )?.map(
                                                          (
                                                            [formula, items],
                                                            formulaIndex
                                                          ) => (
                                                            <React.Fragment
                                                              key={formulaIndex}
                                                            >
                                                              <tr>
                                                                <td
                                                                  colSpan={2}
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                  }}
                                                                >
                                                                  <label>
                                                                    {formula}
                                                                  </label>
                                                                </td>
                                                              </tr>
                                                              {items.map(
                                                                (T) => (
                                                                  <tr
                                                                    key={
                                                                      T.originalIndex
                                                                    }
                                                                  >
                                                                    <td>
                                                                      {
                                                                        T.VariableName
                                                                      }{" "}
                                                                      ={" "}
                                                                      {
                                                                        T.VariableTitle
                                                                      }
                                                                      {T.IsResultRow ==
                                                                        true &&
                                                                        T
                                                                          .FormulaVariables
                                                                          ?.length >
                                                                          0 &&
                                                                        `(${T.FormulaVariables})`}
                                                                    </td>
                                                                    <td>
                                                                      <Field
                                                                        style={{
                                                                          minWidth:
                                                                            "100px",
                                                                        }}
                                                                        type="number"
                                                                        name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignTargetStrengthForMixProportioning[${T.originalIndex}].VariableValue`} // Use the original index here
                                                                        placeholder="Value"
                                                                        component={
                                                                          CustomInput
                                                                        }
                                                                        noMarginBottom={
                                                                          true
                                                                        }
                                                                        disabled={
                                                                          true
                                                                        }
                                                                      />
                                                                    </td>
                                                                  </tr>
                                                                )
                                                              )}
                                                            </React.Fragment>
                                                          )
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>
                                            A-4 APPROXIMATE AIR CONTENT
                                          </label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-0">
                                                  <div
                                                    id="mixDesignApproximateAirContent-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="mixDesignApproximateAirContent-tbl"
                                                      className="table table-bordered no-footer mb-2"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            colSpan={2}
                                                            style={{
                                                              whiteSpace:
                                                                "normal",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                .ApproximateAirContentResultTitle
                                                            }
                                                          </td>
                                                          <td
                                                            rowSpan={2}
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              minWidth: "60px",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                .ApproximateAirContentResultValue
                                                            }
                                                          </td>
                                                          <td
                                                            rowspan={2}
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                .ApproximateAirContentReferenceStandardAndTableName
                                                            }
                                                          </td>
                                                        </tr>
                                                        <tr>
                                                          <td>
                                                            For nominal maximum
                                                            size of aggregate,
                                                          </td>
                                                          <td
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                .MaximumNominalSizeofAggregateName
                                                            }
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>
                                            A-5 SELECTION OF WATER-CEMENT RATIO
                                          </label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={4}>
                                                <Field
                                                  label="Reference Standard"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName`}
                                                  placeholder={
                                                    "Reference Standard"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Reference Standard Table"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName`}
                                                  placeholder={
                                                    "Reference Standard Table"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Concrete Type"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.ConcreteType`}
                                                  placeholder={"Concrete Type"}
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Concrete Grade"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.ConcreteGrade`}
                                                  placeholder={"Concrete Grade"}
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  label="Max Free Water Cement Ratio"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.MaxFreeWaterCementRatio`}
                                                  placeholder={
                                                    "Max Free Water Cement Ratio"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  type="number"
                                                  label="Free Water Cement Ratio"
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.FreeWaterCementRatio`}
                                                  placeholder={
                                                    "Free Water Cement Ratio"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>
                                            A-6 SELECTION OF WATER CONTENT
                                          </label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-0">
                                                  <div
                                                    id="mixDesignA6-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="mixDesignA6-tbl"
                                                      className="table table-bordered no-footer mb-2"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td>
                                                            For nominal maximum
                                                            size of aggregate,
                                                          </td>
                                                          <td
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                ?.MaximumNominalSizeofAggregateName
                                                            }
                                                          </td>
                                                          <td>
                                                            Estimated Water
                                                            Content
                                                          </td>
                                                          <td
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                ?.Workability
                                                            }
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.AsSuperPlasticizerIsUsed`}
                                                  label={
                                                    "As Super Plasticizer is used"
                                                  }
                                                  placeholder={
                                                    "As Super Plasticizer is used"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={8}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.SelectionOfWaterContentReferenceStandardAndTableName`}
                                                  label={
                                                    "Reference Standard With Table Name"
                                                  }
                                                  placeholder={
                                                    "Reference Standard With Table Name"
                                                  }
                                                  component={CustomInput}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={12}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.SelectionOfWaterContentRemarks`}
                                                  label={"Remarks"}
                                                  placeholder={"Remarks"}
                                                  component={CustomTextArea}
                                                  disabled={true}
                                                />
                                              </Col>
                                              {test?.ListOfMixDesignGroupParameters?.map(
                                                (item, indx) =>
                                                  item.GroupName == "A-6" && (
                                                    <>
                                                      <Col lg={4}>
                                                        <Field
                                                          type="number"
                                                          name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignGroupParameters[${indx}].ParameterValue`}
                                                          label={`${
                                                            item.ParameterName
                                                          } ${
                                                            item.ShortCode
                                                              ? "(" +
                                                                item.ShortCode +
                                                                ")"
                                                              : ""
                                                          }`}
                                                          placeholder={`Enter ${item.ParameterName} Value`}
                                                          component={
                                                            CustomInput
                                                          }
                                                          disabled={true}
                                                        />
                                                      </Col>
                                                      {item.IsResultValueBasedOnFormula ==
                                                        true && (
                                                        <Col lg={2}>
                                                          <Field
                                                            type="number"
                                                            name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignGroupParameters[${indx}].ResultValue`}
                                                            label={" "}
                                                            placeholder={`Result Value`}
                                                            component={
                                                              CustomInput
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                      )}
                                                    </>
                                                  )
                                              )}
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>
                                            A-7(I) CALCULATION OF CEMENT CONTENT
                                          </label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.WaterCementRatio`}
                                                  label={"Water Cement Ratio"}
                                                  placeholder={
                                                    "Water Cement Ratio"
                                                  }
                                                  component={CustomInput}
                                                  maxLength={50}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.CementContentKgPerM3FormulaValue`}
                                                  label={
                                                    "Cement Content Kg/m3 Calculation"
                                                  }
                                                  placeholder={
                                                    "Cement Content Kg/m3 Calculation"
                                                  }
                                                  component={CustomInput}
                                                  maxLength={50}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.CementContentKgPerM3ResultValue`}
                                                  label={
                                                    "Cement Content Kg/m3 Result Value"
                                                  }
                                                  placeholder={
                                                    "Cement Content Kg/m3 Calculation"
                                                  }
                                                  component={CustomInput}
                                                  maxLength={50}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.CementContentKgPerM3FinalResult`}
                                                  label={
                                                    "Cement Content Kg/m3 Final Result Value"
                                                  }
                                                  placeholder={
                                                    "Cement Content Kg/m3 Final Result Value"
                                                  }
                                                  component={CustomInput}
                                                  maxLength={50}
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col lg={4}>
                                                <Field
                                                  name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.MinimumCementContent`}
                                                  label={
                                                    "Minimum Cement Content"
                                                  }
                                                  placeholder={
                                                    "Minimum Cement Content"
                                                  }
                                                  component={CustomInput}
                                                  maxLength={50}
                                                  disabled={true}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    {test?.TestMixDesignDetail
                                      ?.TypeofMineralAdmixtureIDEncrypted && (
                                      <>
                                        <hr className="mt-0 mb-1"></hr>
                                        <Row>
                                          <div className="d-flex justify-content-between mb-0">
                                            <div className="d-flex mb-0">
                                              <label>
                                                A-7(II) CALCULATION OF
                                                CEMENTITOUS MATERIAL / Mineral
                                                Admixture
                                              </label>
                                            </div>
                                          </div>
                                          <Col lg={12}>
                                            <div
                                              className="card mb-2"
                                              style={{ height: "auto" }}
                                            >
                                              <div className="card-body p-2">
                                                <Row>
                                                  <Col lg={12}>
                                                    In certain situations,
                                                    increase in cementitious
                                                    material content may be
                                                    warranted. The decision on
                                                    increase in cementitious
                                                    material content and its
                                                    percentage may be based on
                                                    experience and trials.
                                                  </Col>
                                                  <Col lg={4}>
                                                    <label>
                                                      Cementitious material
                                                      content kg/m3:
                                                    </label>
                                                  </Col>
                                                  <Col lg={4}>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.CementitiousMaterialContentIsTakenAsMoreOrLessPercentage`}
                                                      label={
                                                        "Is Taken as More Or Less %"
                                                      }
                                                      placeholder={
                                                        "Is Taken as More Or Less %"
                                                      }
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      disabled={true}
                                                    />
                                                  </Col>
                                                  <Col lg={4}>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.CementitiousMaterialContentOfCementContentPercentage`}
                                                      label={
                                                        "Of Cement Content %"
                                                      }
                                                      placeholder={
                                                        "Of Cement Content %"
                                                      }
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      disabled={true}
                                                    />
                                                  </Col>
                                                  <Col lg={4}>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.CementContentKgPerM3`}
                                                      label={
                                                        "Cement Content Kg/m3"
                                                      }
                                                      placeholder={
                                                        "Cement Content Kg/m3"
                                                      }
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      disabled={true}
                                                    />
                                                  </Col>
                                                  <Col lg={4}>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.WaterContentKgPerM3`}
                                                      label={
                                                        "Water Content Kg/m3"
                                                      }
                                                      placeholder={
                                                        "Water Content Kg/m3"
                                                      }
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      disabled={true}
                                                    />
                                                  </Col>
                                                  <Col lg={4}>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.WaterCementRatioCementitiousMaterial`}
                                                      label={
                                                        "Water Cement Ratio"
                                                      }
                                                      placeholder={
                                                        "Water Cement Ratio"
                                                      }
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      disabled={true}
                                                    />
                                                  </Col>
                                                  <Col lg={4}>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMaterialTests[${tIndex}].TestMixDesignDetail.CementitiousMaterialContentKgPerM3`}
                                                      label={
                                                        "Cementitious Material Content Kg/m3"
                                                      }
                                                      placeholder={
                                                        "Cementitious Material Content Kg/m3"
                                                      }
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      disabled={true}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </>
                                    )}
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>
                                            A-8 PROPORTION OF VOLUME OF COARSE
                                            AGGREGATE AND FINE AGGREGETE CONTENT
                                          </label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-0">
                                                  <div
                                                    id="A-8-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="A-8-tbl"
                                                      className="table table-bordered no-footer mb-2"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td>
                                                            For nominal maximum
                                                            size of aggregate,
                                                          </td>
                                                          <td
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                .MaximumNominalSizeofAggregateName
                                                            }
                                                          </td>
                                                        </tr>
                                                        <tr>
                                                          <td>
                                                            Fine Aggregate
                                                            grading Zone
                                                          </td>
                                                          <td
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {
                                                              test
                                                                ?.TestMixDesignDetail
                                                                .FineAggregateConformingToGradingZone
                                                            }
                                                          </td>
                                                        </tr>
                                                        {test?.ListOfMixDesignGroupParameters?.map(
                                                          (item, indx) =>
                                                            (item.GroupName ==
                                                              "A-8" ||
                                                              (item.GroupName ==
                                                                "A-8." &&
                                                                test
                                                                  ?.TestMixDesignDetail
                                                                  .MethodofConcretePlacingIsPumping ==
                                                                  true)) && (
                                                              <tr>
                                                                <td
                                                                  style={{
                                                                    whiteSpace:
                                                                      "normal",
                                                                    minWidth:
                                                                      "100px",
                                                                    maxWidth:
                                                                      "300px",
                                                                  }}
                                                                >
                                                                  <label>{`${
                                                                    item.ParameterName
                                                                  } ${
                                                                    item.ShortCode
                                                                      ? "(" +
                                                                        item.ShortCode +
                                                                        ")"
                                                                      : ""
                                                                  }`}</label>
                                                                </td>
                                                                <td
                                                                  style={{
                                                                    minWidth:
                                                                      "100px",
                                                                    maxWidth:
                                                                      "100px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    type="number"
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignGroupParameters[${indx}].ParameterValue`}
                                                                    placeholder={`Enter ${item.ParameterName} Value`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                </td>
                                                                {item.IsResultValueBasedOnFormula ==
                                                                  true && (
                                                                  <td
                                                                    style={{
                                                                      minWidth:
                                                                        "100px",
                                                                      maxWidth:
                                                                        "100px",
                                                                    }}
                                                                  >
                                                                    <Field
                                                                      type="number"
                                                                      name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignGroupParameters[${indx}].ResultValue`}
                                                                      placeholder={`Result Value`}
                                                                      component={
                                                                        CustomInput
                                                                      }
                                                                      maxLength={
                                                                        50
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    />
                                                                  </td>
                                                                )}
                                                                {item?.Remarks && (
                                                                  <td
                                                                    style={{
                                                                      minWidth:
                                                                        "100px",
                                                                    }}
                                                                    colSpan={2}
                                                                  >
                                                                    <Field
                                                                      // label="Remarks"
                                                                      name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignGroupParameters[${indx}].Remarks`}
                                                                      placeholder={`Remarks`}
                                                                      component={
                                                                        CustomTextArea
                                                                      }
                                                                      rows={5}
                                                                      maxLength={
                                                                        2000
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    />
                                                                  </td>
                                                                )}
                                                              </tr>
                                                            )
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>A-9 MIX CALCULATIONS</label>
                                        </div>
                                      </div>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-0">
                                                  <div
                                                    id="A-9-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="A-9-tbl"
                                                      className="table table-bordered no-footer mb-2"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            colSpan={4}
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            The mix calculations
                                                            per unit volume of
                                                            concrete shall be as
                                                            follows:
                                                          </td>
                                                        </tr>
                                                        {test?.ListOfMixDesignMixCalculation?.map(
                                                          (item, indx) => (
                                                            <tr>
                                                              <td>
                                                                {item.ParameterShortCode
                                                                  ? `${item.ParameterShortCode}) `
                                                                  : ""}
                                                                {
                                                                  item.ParameterName
                                                                }
                                                              </td>
                                                              <td
                                                                style={{
                                                                  minWidth:
                                                                    "200px",
                                                                  whiteSpace:
                                                                    "normal",
                                                                }}
                                                              >
                                                                {
                                                                  item.ParameterFormula
                                                                }
                                                              </td>
                                                              <td
                                                                style={{
                                                                  minWidth:
                                                                    "100px",
                                                                }}
                                                              >
                                                                {
                                                                  item.ParameterFormulaValue
                                                                }
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textAlign:
                                                                    "center",
                                                                  minWidth:
                                                                    "100px",
                                                                }}
                                                              >
                                                                <div className="d-flex">
                                                                  <Field
                                                                    type="number"
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixCalculation[${indx}].ParameterResultValue`}
                                                                    placeholder={`Value`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                  <div
                                                                    className="mt-1 me-1"
                                                                    style={{
                                                                      width:
                                                                        "10%",
                                                                    }}
                                                                  >
                                                                    &nbsp;
                                                                    {
                                                                      item.ResultUnit
                                                                    }
                                                                  </div>
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr className="mt-0 mb-1"></hr>
                                    <Row>
                                      <Col lg={12}>
                                        <div
                                          className="card mb-2"
                                          style={{ height: "auto" }}
                                        >
                                          <div className="card-body p-2">
                                            <Row>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-0">
                                                  <div
                                                    id="mixProportionsForTrial-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="mixProportionsForTrial-tbl"
                                                      className="table table-bordered no-footer mb-2"
                                                    >
                                                      <thead>
                                                        <tr>
                                                          <th
                                                            colSpan={3}
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                            }}
                                                          >
                                                            A-10 MIX PROPORTIONS
                                                            FOR TRIAL
                                                          </th>
                                                          <th
                                                            colSpan={2}
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                            }}
                                                          >
                                                            A-11 ADJUSTMENT ON
                                                            WATER, FINE
                                                            AGGREGATE AND COARSE
                                                            AGGREGATE (IF THE
                                                            COARSE AND FINE
                                                            AGGREGATE IS IN DRY
                                                            CONDITION)
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                            }}
                                                          >
                                                            A-12 MIX PROPORTIONS
                                                            AFTER ADUSTMENT FOR
                                                            DRY AGGREGATES
                                                          </th>
                                                          <th
                                                            colSpan={4}
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                            }}
                                                          >
                                                            A-12 LABORATORY MIX
                                                            TRIAL PROPORTIONS
                                                            AFTER MOSTURE
                                                            CONTENT CORRECTION
                                                          </th>
                                                        </tr>
                                                        <tr>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                            }}
                                                          >
                                                            Sr. No.
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Type of material
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Per m3 of Concrete,
                                                            Kg (SSD- Aggregates
                                                            shall be used in
                                                            saturated surface
                                                            dry condition)
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Water Absorption %
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Weight of W.A,kg
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Per m3 of Concrete,
                                                            Kg after water
                                                            absorption
                                                            correction
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Moisture content %
                                                            of aggregate
                                                            {/* [As per
                                                            IS 2386 (Part 3)]: */}
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Moisture content
                                                            weigth,kg
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            Per m3 of Concrete,
                                                            Kg after Moisture
                                                            content correction
                                                          </th>
                                                          <th
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              whiteSpace:
                                                                "normal",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            0.027 m3 of concrete
                                                            , Kg for Laboratory
                                                            Mix Trial proportion
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {test?.ListOfMixDesignMixProportionsForTrial?.map(
                                                          (item, indx) => (
                                                            <tr>
                                                              <td
                                                                style={{
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {item?.SrNo == 0
                                                                  ? ""
                                                                  : item?.SrNo}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textAlign:
                                                                    "center",
                                                                  whiteSpace:
                                                                    "normal",
                                                                }}
                                                              >
                                                                {
                                                                  item?.TypeOfMaterial
                                                                }
                                                              </td>
                                                              <td
                                                                style={{
                                                                  minWidth:
                                                                    "150px",
                                                                  verticalAlign:
                                                                    "middle",
                                                                }}
                                                              >
                                                                <div className="d-flex">
                                                                  {(item?.MaterialShortCode ==
                                                                    "CA20" ||
                                                                    item?.MaterialShortCode ==
                                                                      "CA10") && (
                                                                    <Field
                                                                      type="text"
                                                                      name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].CoarseAggregatePercentageOfFraction`}
                                                                      placeholder={`Percentage(%)`}
                                                                      component={
                                                                        CustomInput
                                                                      }
                                                                      maxLength={
                                                                        50
                                                                      }
                                                                      noMarginBottom={
                                                                        true
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    />
                                                                  )}
                                                                  <Field
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKg`}
                                                                    placeholder={`Value`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                {item?.SrNo && (
                                                                  <Field
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].WaterAbsorptionPercentage`}
                                                                    placeholder={`Value`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                              <td>
                                                                {item?.SrNo && (
                                                                  <Field
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].WeightOfWaterAbsorptionKg`}
                                                                    placeholder={`Value`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                              <td>
                                                                <Field
                                                                  name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`}
                                                                  placeholder={`Value`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  maxLength={50}
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    true
                                                                  }
                                                                />
                                                              </td>
                                                              <td>
                                                                {item?.SrNo && (
                                                                  <Field
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].MoistureContentPercentageOfAggregate`}
                                                                    placeholder={`Value`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                              <td>
                                                                {item?.SrNo && (
                                                                  <Field
                                                                    name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].MoistureContentWeightKg`}
                                                                    placeholder={`Value`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                              <td>
                                                                <Field
                                                                  name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKgAfterMoistureContentCorrection`}
                                                                  placeholder={`Value`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  maxLength={50}
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    true
                                                                  }
                                                                />
                                                              </td>
                                                              <td>
                                                                <Field
                                                                  name={`ListOfMaterialTests[${tIndex}].ListOfMixDesignMixProportionsForTrial[${indx}].LaboratoryMixTrialProportion`}
                                                                  placeholder={`Value`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  maxLength={50}
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    true
                                                                  }
                                                                />
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                              </>
                            )}
                        </div>
                      </Accordion.Collapse>
                    </Accordion.Item>
                  ))}
                </Accordion>
                {showTCAllTestApprovalModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showTestMasterImagesModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showTestingResultImagesModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showLetterRefDocModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showTPIDetailModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showDefineMoreRatesModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
              </Form>
            </FormikProvider>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button
              variant="secondary light"
              onClick={() => setShowTestingApprovalModal(false)}
            >
              Close
            </Button>
          </Modal.Footer> */}
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showTCAllTestApprovalModal}
        onHide={setShowTCAllTestApprovalModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Approve All</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTCAllTestApprovalModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <FormikProvider value={formikApproval}>
              <Form onSubmit={formikApproval.handleSubmit}>
                <Row>
                  <Col lg={12}>
                    <label className="mb-1">Instruction:</label>
                    <ul className="unorder-list ps-4 mb-2">
                      <li>
                        Selected TC included all test should be approve / revise
                        & rectify.
                      </li>
                      <li>
                        Approval note should be apply to all test of selected
                        TC.
                      </li>
                      <li>
                        Only Unapproved Test should be approve / revise &
                        rectify. Other remains as it is.
                      </li>
                    </ul>
                  </Col>
                  <Col lg={12}>
                    <Field
                      type="text"
                      name={"ApprovalNoteForApproveAll"}
                      component={CustomInput}
                      placeholder="Approval Note"
                      maxLength={100}
                    />
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              // className="btn btn-primary"
              className="btn btn-primary btn-sm"
              onClick={() => {
                ApproveRejectTCAllTest(4);
              }}
            >
              <i className="fa fa-circle-check"></i> Approve
            </button>
            &nbsp;
            <button
              type="button"
              // className="btn btn-danger light"
              className="btn btn-primary btn-sm"
              onClick={() => {
                ApproveRejectTCAllTest(5);
              }}
            >
              <i className="fa fa-rotate-left"></i> Revise & Rectify
            </button>
            <Button
              // variant="secondary light"
              variant="danger btn-sm"
              onClick={() => setShowTCAllTestApprovalModal(false)}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showTestMasterImagesModal}
        onHide={setShowTestMasterImagesModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Test Master Images</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTestMasterImagesModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive active-projects style-1 shorting mb-2">
              <div
                id="TestMasterImages-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="TestMasterImages-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="2%"></th>
                      <th width="98%" style={{ textAlign: "left" }}>
                        Image Preview
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listTestMasterImages?.length > 0 ? (
                      listTestMasterImages?.map((item, indx) => (
                        <tr>
                          <td>
                            <Link
                              to="#"
                              // className="icon-box icon-box-md bg-primary-light me-1"
                              className="icon-box icon-box-md me-1"
                              title="View"
                              onClick={() => {
                                window.open(item.ImageFilePath, "_blank");
                              }}
                            >
                              <i className="fa fa-eye"></i>
                            </Link>
                          </td>
                          <td>
                            <div
                              className="image-placeholder"
                              style={{
                                maxWidth: "100px",
                                margin: "10px",
                                zIndex: 0,
                              }}
                            >
                              <div
                                className="avatar-preview"
                                style={{
                                  width: "100px",
                                  height: "auto",
                                }}
                              >
                                <div id="testMasterImagePreview">
                                  <img
                                    id="saveTestMasterImageFile"
                                    src={item.ImageFilePath}
                                    alt={"Image"}
                                    onClick={() => {
                                      window.open(item.ImageFilePath, "_blank");
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showTestingResultImagesModal}
        onHide={setShowTestingResultImagesModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Testing Images</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTestingResultImagesModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive active-projects style-1 shorting mb-2">
              <div
                id="TestMasterImages-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="TestMasterImages-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="2%"></th>
                      <th width="98%" style={{ textAlign: "left" }}>
                        Image Preview
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listOfTestingResultImages?.length > 0 ? (
                      listOfTestingResultImages?.map((item, indx) => (
                        <tr>
                          <td>
                            <Link
                              to="#"
                              // className="icon-box icon-box-md bg-primary-light me-1"
                              className="icon-box icon-box-md me-1"
                              title="View"
                              onClick={() => {
                                window.open(item.ResultImagePath, "_blank");
                              }}
                            >
                              <i className="fa fa-eye"></i>
                            </Link>
                          </td>
                          <td style={{ textAlign: "left" }}>
                            <div
                              className="image-placeholder"
                              style={{
                                maxWidth: "100px",
                                margin: "10px",
                                zIndex: 0,
                              }}
                            >
                              <div
                                className="avatar-preview"
                                style={{
                                  width: "100px",
                                  height: "auto",
                                }}
                              >
                                <div id="resultImagePathPreview">
                                  <img
                                    id="saveResultImagePath"
                                    src={item.ResultImagePath}
                                    alt={"Image"}
                                    onClick={() => {
                                      window.open(
                                        item.ResultImagePath,
                                        "_blank"
                                      );
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <span className="fs-12">{item.Remarks}</span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showLetterRefDocModal}
        onHide={setShowLetterRefDocModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowLetterRefDocModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="MaterialPhotos-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="MaterialPhotos-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="2%"></th>
                          <th width="98%" style={{ textAlign: "left" }}>
                            File Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfLetterRefDoc?.length > 0 ? (
                          ListOfLetterRefDoc?.map((item, indx) => (
                            <tr key={indx}>
                              <td style={{ textAlign: "left" }}>
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="View"
                                  onClick={() => {
                                    window.open(
                                      item.LetterRefImageFilePath
                                        ? item.LetterRefImageFilePath
                                        : item.viewFile
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye" />
                                </Link>
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {item?.LetterRefImageFileName
                                  ? item?.LetterRefImageFileName
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showTPIDetailModal}
        onHide={setShowTPIDetailModal}
        size="lg"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>TPI Detail</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTPIDetailModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="TPIdetail-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="TPIdetail-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="40%">TPI</th>
                          <th width="40%">TPI Contact Person</th>
                          <th width="20%" style={{ textAlign: "left" }}>
                            TPI Expected Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {listOfTPIDetails?.length > 0 ? (
                          listOfTPIDetails?.map((item, indx) => (
                            <tr key={indx}>
                              <td>{item.TPIName}</td>
                              <td>{item.TPIContactPersonName}</td>
                              <td style={{ textAlign: "left" }}>
                                {item.TPIExpectedDate}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showDefineMoreRatesModal}
        onHide={setShowDefineMoreRatesModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikDefineMoreRates}>
            <Form onSubmit={formikDefineMoreRates.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Define More Rates</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="DefineMoreRates-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="DefineMoreRates-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead className="fixedheader">
                            <tr>
                              <th width="5%" className="ps-1"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Rate Type
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {MoreTestRatesList?.length > 0 ? (
                              MoreTestRatesList?.map((tRate, tRateindx) => (
                                <tr key={`para_${tRateindx}`}>
                                  <td className="p-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkIsSelected${tRateindx}`}
                                      name={`chkIsSelected${tRateindx}`}
                                      checked={tRate.IsSelected}
                                      disabled={true}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    {tRate.RateTypeName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={2}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              {/* <Modal.Footer>
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer> */}
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
    </>
  );
};

export default TestingApproval;
